// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"c2eb5c70","829":"37e1f7ba","968":"cd37e7b9","991":"0047de64"}[chunkId] + ".css";
};